import React, { useEffect, useMemo, useState } from 'react';
// import { useHistory } from 'react-router-dom';
// import _ from 'lodash';
import { Tooltip, IconButton, Button } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import PreviewIcon from '@material-ui/icons/ImageSearch';
import useCreateDraftPpsi from '../features/PpsiContainer/hooks/useCreateDraftPpsi';
import useCreateDraftVersionPpi from '../features/PpiContainer/hooks/useCreateDraftVersionPpi';
import { useUnpublishPpi } from '../features/PpiContainer/hooks/usePpiAction';
import { useUnpublishPpsi } from '../features/PpsiContainer/hooks/usePpsiAction';
import MessageIcon from '@material-ui/icons/Message';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import FileOpenIcon from '@material-ui/icons/OpenInNew';
import EditIcon from '@material-ui/icons/Edit';
import { getConfigs } from '../features/app/selectors';
import Table from '../components/Table/Table';
import useViewVisited from '../features/app/hooks/useViewVisted';
import {
  EnrichmentData as PpsiEnrichmentData,
  States as PpsiStates,
  States
} from '../features/PpsiContainer/constants';
import {
  EnrichmentData as PpiEnrichmentData,
  States as PpiStates
} from '../features/PpiContainer/constants';
import {
  ppiPublishedRoute,
  ppsiPublishedRoute,
  ppiInProgressRoute,
  ppsiInProgressRoute
} from '../routes';
import ProgressFullscreen from '../components/common/ProgressFullscreen';
import View from './views';
import PaperContainer from '../components/common/PaperContainer';
import usePreviewPpi from '../features/PpiContainer/hooks/usePreviewPpi';
import usePreviewPpsi from '../features/PpsiContainer/hooks/usePreviewPpsi';
import { toJS } from '../utils/immutableUtils';
import { stitchPpis } from '../utils/ui2pStitchPPI';
import stichPpsi from '../utils/ui2pStitchPPSI';
import useUpdatesGlobalPpsis from 'features/PpsiContainer/hooks/useUpdatesGlobalPpsis';
import useGlobalPpisUpdates from 'features/PpiContainer/hooks/useGlobalPpisUpdates';
import usePpisUpdates from 'features/PpiContainer/hooks/usePpisUpdates';
import useUpdatesPpsis from 'features/PpsiContainer/hooks/useUpdatesPpsis';
import { all } from 'redux-saga/effects';
import { getPpsisWithFilter } from 'features/PpsiContainer/selectors';
import {
  getIsFetching,
  getPpisNotUptoDate,
  getPpisWithStatus,
  getRelatedPpis,
  getIsFetchingPpis
} from 'features/PpiContainer/selectors';
import useAlert from 'features/alertSystem/hooks/useAlert';
import { fetchPpisRelatedToPpsi } from 'features/PpiContainer/actions';
import { getIsGlobalUser } from 'features/loginSystem/selectors';
// import UpdatesIcon from '../components/common/UpdatesIcon';

function isRowPpsi(rowData) {
  return rowData.type === 'PPSI';
}

function getEnrichmentData(rowData) {
  let enrichmentDataName;
  if (rowData.status === 'INPROGRESS') {
    enrichmentDataName = isRowPpsi(rowData)
      ? PpsiEnrichmentData.IN_PROGRESS
      : PpiEnrichmentData.IN_PROGRESS;
  } else {
    enrichmentDataName = isRowPpsi(rowData)
      ? PpsiEnrichmentData.PUBLISHED
      : PpiEnrichmentData.PUBLISHED;
  }
  return rowData[enrichmentDataName];
}

function getParentPpsiId(data) {
  return data.status === 'INPROGRESS'
    ? data.inProgressPpsiEnrichmentData.parentPpsiId
    : data.publishedPpsiEnrichmentData.parentPpsiId;
}

function getParentPpiId(data) {
  return data.status === 'INPROGRESS'
    ? data.inProgressPPIEnrichmentData.parentPpiId
    : data.publishedPPIEnrichmentData.parentPpiId;
}

function hasDraft(rowData) {
  let enrichmentDataName;
  enrichmentDataName = isRowPpsi(rowData)
    ? PpsiEnrichmentData.IN_PROGRESS
    : PpiEnrichmentData.IN_PROGRESS;

  return (
    rowData[enrichmentDataName] !== undefined &&
    rowData[enrichmentDataName] !== null
  );
}

function createTableData(ppsis, ppis) {
  const ppsisWithType = ppsis.map(ppsi => ppsi.set('type', 'PPSI'));
  const ppisWithType = ppis.map(ppi => ppi.set('type', 'PPI'));
  return ppsisWithType.concat(ppisWithType);
}

function getPublishedData(ppsi) {
  const data = ppsi.publishedPpsiEnrichmentData;
  const dish = data.referencedIFoodData;
  return {
    ...data,
    ppsiId: ppsi.id,
    dish
  };
}

function getPPI_PPSIEnrichmentData(ppsi) {
  const data = getEnrichmentData(ppsi);
  const dish = data.referencedIFoodData;
  return {
    ...data,
    ppsiId: ppsi.id,
    dish
  };
}

function getPPSINotificationMessage(
  notification,
  globalPpsi,
  parentPpsiEnrichmentDataId
) {
  if (notification.message.startsWith('Parent PPSI')) {
    return globalPpsi &&
      globalPpsi.publishedPpsiEnrichmentData &&
      globalPpsi.publishedPpsiEnrichmentData.id !== parentPpsiEnrichmentDataId
      ? globalPpsi.publishedPpsiEnrichmentData.info['EN-IF'].versionComment
      : '';
  }
  return notification.message;
}

function getPPINotificationMessage(
  notification,
  globalPpi,
  parentPpiEnrichmentDataId
) {
  if (notification.message.startsWith('Parent PPI')) {
    return globalPpi &&
      globalPpi.publishedPPIEnrichmentData &&
      globalPpi.publishedPPIEnrichmentData.id !== parentPpiEnrichmentDataId
      ? globalPpi.publishedPPIEnrichmentData.info['EN-IF'].versionComment
      : '';
  }
  return notification.message;
}

const formatFormulaCode = (formulaCode, version) => {
  return (
    formulaCode.substring(0, 3) +
    ' ' +
    formulaCode.substring(3, 7) +
    ' ' +
    formulaCode.substring(7, formulaCode.length) +
    '\\' +
    version
  );
};

const formatItemCode = itemCode => {
  return (
    itemCode.substring(0, 3) +
    ' ' +
    itemCode.substring(3, 7) +
    ' ' +
    itemCode.substring(7, itemCode.length)
  );
};

const NewUpdatesListView = () => {
  // const history = useHistory();
  const getConfigData = useSelector(getConfigs).toJS();
  // const [isFetchingPpis] = usePpis(States.UPDATES);
  // const [isFetchingPpsis] = usePpsis({ status: States.UPDATES });
  const dispatch = useDispatch();
  const isFetchingPpi = useSelector(getIsFetching);

  const [isFetchingPpis] = usePpisUpdates();
  const [isFetchingPpsis] = useUpdatesPpsis();
  const [ppsiId, setPpsiId] = useState(null);
  const isGlobalUser = useSelector(getIsGlobalUser);

  const filter = useMemo(() => ({ matchingNotUptoDate: true }), []);
  const ppsis = useSelector(getPpsisWithFilter(filter));
  const ppis = useSelector(getPpisNotUptoDate());
  const relatedPpiss = toJS(useSelector(getRelatedPpis));
  const isFetchingRelatedPpis = useSelector(getIsFetchingPpis);
  const [previewNodePPI, openPreviewPPI] = usePreviewPpi();
  const [previewNodePPSI, openPreviewPPSI] = usePreviewPpsi();
  //  const isFetchingGlobalPpis = useSelector(getIsFetching);
  //   const globalPpisRaw = useSelector(getGlobalPpisUpdates());
  const [isFetchingGlobalPpis, globalPpisRaw] = useGlobalPpisUpdates();
  const [isFetchingGlobalPpsis, globalPpsisRaw] = useUpdatesGlobalPpsis();
  const isFetching =
    isFetchingPpis ||
    isFetchingPpsis ||
    isFetchingGlobalPpis ||
    isFetchingGlobalPpsis;
  const { isViewVisited } = useViewVisited('UPDATES_LIST', isFetching);
  const isFetched = isViewVisited ? true : !isFetching;
  const [unpublishPpi, isUnpublishingPpi] = useUnpublishPpi();
  const [unpublishPpsi, isUnpublishingPpsi] = useUnpublishPpsi();
  const [createDraftPpi] = useCreateDraftVersionPpi();

  const [createDraftPpsi] = useCreateDraftPpsi();

  const globalPpsis = toJS(globalPpsisRaw, []);
  const globalPpis = toJS(globalPpisRaw, []);
  const [openAlert, closeAlert] = useAlert();
  const ppisWithStatus = useSelector(getPpisWithStatus('PUBLISHED'));
  const ppiss = toJS(ppisWithStatus);

  // if (isCreateDraftDone) {
  //   return <Redirect to={ppsiInProgressRoute(id)} />;
  // }

  // if (isCreateDraftppiDone) {
  //   return <Redirect to={ppiInProgressRoute(id)} />;
  // }
  const [temp, setTemp] = useState(1);

  const updateCategory =
    getConfigData && getConfigData.updateCategory.map(item => item);

  function handlePpsiDraft(id) {
    createDraftPpsi(id);
  }

  const handleUnpublish = rowData => {
    //dispatch(deleteFeedback(item.id));
    openAlert({
      title: '',
      content: `Are you sure, you want to unpublish this ${
        isRowPpsi(rowData) ? 'PPSI' : 'PPI'
      } instruction?`,
      actions: {
        right: (
          <>
            <Button key="stay" onClick={closeAlert} color="primary">
              No
            </Button>
            <Button
              key="leave"
              onClick={() => {
                isRowPpsi(rowData)
                  ? unpublishPpsi(rowData.id)
                  : unpublishPpi(rowData.id);
                closeAlert();
              }}
              color="secondary"
            >
              Yes, unpublish
            </Button>
          </>
        )
      }
    });
  };

  const [currentPpsi, setCurrentPpsi] = useState(null);
  const enablePreview = ppisRelatedToPpsi => {
    const {
      ppiDetails,
      referencedIFoodData,
      updateNotificationList
    } = getEnrichmentData(currentPpsi.rowData);
    let usedPpis = [];
    const ppiDataIds = ppiDetails
      .filter(ppiDetail => ppiDetail.ppiEnrichmentDataId)
      .map(ppiDetail => ppiDetail.ppiEnrichmentDataId);
    // referencedIngredientEntities
    // const ppisRelatedToPpsi = relatedPpi.filter(ppi=>getEnrichmentData(ppi).upToDate)
    if (ppiDataIds.length) {
      usedPpis =
        ppisRelatedToPpsi &&
        ppisRelatedToPpsi
          .filter(
            ppi =>
              getEnrichmentData(ppi) &&
              ppiDataIds.includes(getEnrichmentData(ppi).id)
          )
          .map(ppi => getEnrichmentData(ppi));
    }

    const ppsi =
      temp > 0 &&
      // ppisRelatedToPpsi.length &&
      stichPpsi(
        getPPI_PPSIEnrichmentData(currentPpsi.rowData),
        stitchPpis(usedPpis),
        referencedIFoodData.referencedIngredientEntities,
        currentPpsi.language
      );
    const getExcludedItemCodes =
      ppiDetails &&
      ppiDetails.filter(i => i.ppiNotRequired === true).map(i => i.itemCode);

    const ppiWithoutExcludeData =
      ppsi &&
      ppsi.ppiDetails.filter(i => !getExcludedItemCodes.includes(i.itemCode));
    const finalPpsi = {
      ...ppsi,
      ppiDetails: ppiWithoutExcludeData,
      updateNotificationList: updateNotificationList
    };
    temp > 0 &&
      // ppisRelatedToPpsi.length &&
      openPreviewPPSI(
        finalPpsi,
        currentPpsi.ifoodUpdates.length > 0 ? currentPpsi.language : 'EN-IF'
      );
  };

  useEffect(() => {
    const ppisRelatedToPpsi = ppiss.filter(
      ppi => getEnrichmentData(ppi).upToDate
    );

    if (
      // ppisRelatedToPpsi.length > 0 &&
      currentPpsi &&
      currentPpsi.ifoodUpdates.length > 0 &&
      !isGlobalUser &&
      !isFetchingRelatedPpis
    ) {
      enablePreview(relatedPpiss);
      setCurrentPpsi(null);
    }
  }, [relatedPpiss.length, currentPpsi, isFetchingRelatedPpis]);
  // console.log(ppiss, 'ppiss');

  const UpdatesColumns = {
    Type: {
      name: 'type',
      label: 'Type',
      dataField: 'type',
      filterable: true,
      sortable: false,
      width: 75,
      grow: 0,
      shrink: 0
    },
    Status: {
      name: 'status',
      calculateCellValue: rowData => {
        const { enrichmentStatus, status } = getEnrichmentData(rowData);
        return enrichmentStatus || status;
      },
      filterable: true,
      sortable: false,
      label: 'Status',
      width: 120,
      grow: 0,
      shrink: 0
    },
    Code: {
      name: 'code',
      label: 'iFood ID',
      calculateCellValue: rowData => {
        if (isRowPpsi(rowData)) {
          return formatFormulaCode(rowData.formulaCode, rowData.formulaVersion);
        }
        return formatItemCode(rowData.itemCode);
      },
      width: 150,
      grow: 0,
      shrink: 0
    },
    Category: {
      name: 'category',
      label: 'Category',
      calculateCellValue: (rowData, { language }) => {
        const { updateNotificationList } = getEnrichmentData(rowData);
        const categoryEnum = updateNotificationList.map(i => i.category);

        // REMOVING THE DUPLICATE CATEGORY
        const finalCategoryEnum = [...new Set(categoryEnum)];

        // FILTERING THE CATEGORY FROM THE GLOBAL CONFIG TO GET NAME, MESSAGE AND PRIORITY
        const displayCategoryList = updateCategory.filter(i =>
          finalCategoryEnum.includes(i.enum)
        );

        // Sorting category update based on priority;
        const displayCategory = displayCategoryList.sort(
          (a, b) => a.priority - b.priority
        );

        // Joining multiple category name and message to show in table.
        const CategoryName = displayCategory.map(i => i.name).join(', ');
        // const CategoryMessage = displayCategory.map(i => i.message).join(', ');

        return CategoryName;
      },
      filterable: true,
      sortable: false,
      width: 100,
      grow: 0,
      shrink: 0
    },
    CategoryMessage: {
      name: 'categoryMessage',
      label: '',
      CellValue: rowData => {
        const { updateNotificationList } = getEnrichmentData(
          rowData.rowData.data
        );
        const categoryEnum = updateNotificationList.map(i => i.category);

        // REMOVING THE DUPLICATE CATEGORY
        const finalCategoryEnum = [...new Set(categoryEnum)];

        // FILTERING THE CATEGORY FROM THE GLOBAL CONFIG TO GET NAME, MESSAGE AND PRIORITY
        const displayCategoryList = updateCategory.filter(i =>
          finalCategoryEnum.includes(i.enum)
        );

        // Sorting category update based on priority;
        const displayCategory = displayCategoryList.sort(
          (a, b) => a.priority - b.priority
        );

        // Joining multiple category name and message to show in table.
        const CategoryMessage = displayCategory.map(i => i.message).join(', ');

        return (
          <>
            {CategoryMessage.length > 0 && (
              <Tooltip title={CategoryMessage}>
                <IconButton color="action" size="medium">
                  <MessageIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </>
        );
      },
      filterable: false,
      sortable: false,
      width: 50,
      grow: 0,
      shrink: 0
    },
    PresentationName: {
      name: 'presentationName',
      label: 'Product Name',
      calculateCellValue: (rowData, { language }) => {
        const { info } = getEnrichmentData(rowData);
        return info[language].presentationName; // Return plain text for searching
      },
      // Default cell styling with a function
      style: rowData => {
        const { updateNotificationList } = getEnrichmentData(rowData);
        const isOverdue = updateNotificationList.some(
          notification => notification.overdue
        );

        return {
          color: isOverdue ? 'red' : '#0058A3' // Apply red color if overdue
        };
      },
      // Link logic: Ensure this directs to the appropriate route
      link: rowData => {
        if (rowData.status === 'INPROGRESS') {
          return isRowPpsi(rowData)
            ? ppsiInProgressRoute(rowData.id)
            : ppiInProgressRoute(rowData.id);
        }
        return isRowPpsi(rowData)
          ? ppsiPublishedRoute(rowData.id)
          : ppiPublishedRoute(rowData.id);
      },
      width: 160,
      grow: 0,
      shrink: 0
    },
    Updates: {
      name: 'updates',
      calculateCellValue: rowData => {
        if (rowData.type === 'PPSI') {
          const {
            updateNotificationList,
            parentPpsiEnrichmentDataId
          } = getEnrichmentData(rowData);
          const getPpsiId = getParentPpsiId(rowData);

          const globalPpsi = globalPpsis.find(
            ppsi => ppsi && ppsi.id === getPpsiId
          );

          const message = updateNotificationList
            .map(notification =>
              getPPSINotificationMessage(
                notification,
                globalPpsi,
                parentPpsiEnrichmentDataId
              )
            )
            .join(', ');
          return message;
        }
        const {
          updateNotificationList,
          parentPpiEnrichmentDataId
        } = getEnrichmentData(rowData);
        const getPpiId = getParentPpiId(rowData);
        const globalPpi =
          Object.keys(globalPpis).length > 0 &&
          globalPpis.find(ppi => ppi && ppi.id === getPpiId);

        const message = updateNotificationList
          .map(notification =>
            getPPINotificationMessage(
              notification,
              globalPpi,
              parentPpiEnrichmentDataId
            )
          )
          .join(', ');
        return message;
      },
      label: 'Updates'
      // width: 360,
      // grow: 0,
      // shrink: 0
    },
    AllOtherActions: {
      name: 'allotheractions',
      calculateCellValue: rowData => {
        const { updateNotificationList } = getEnrichmentData(rowData);
        const ifoodUpdates = updateNotificationList.filter(
          i =>
            i.category.includes('IFOOD_UPDATE') &&
            i.message.includes('Discontinued')
        );
        const discontinuedUpdate = updateNotificationList.filter(i =>
          i.category.includes(
            'GLOBAL_PPSI_DISCONTINUED' || 'GLOBAL_PPI_DISCONTINUED'
          )
        );
        const alternateUpdates = updateNotificationList.filter(i =>
          i.category.includes('ALTERNATE')
        );
        const draftExist = hasDraft(rowData);
        const hasPublished = rowData.status !== 'INPROGRESS';
        const hasUnPublished = rowData.status === 'UNPUBLISHED';

        return (
          <>
            {/* This is the Remove notification / IGNORE notification functionality */}
            {/* {!hasPublished &&
              ifoodUpdates.length === 0 &&
              alternateUpdates.length !== 0 && (
                <Tooltip title="Close notification">
                  <IconButton
                    onClick={() => {
                      if (rowData.type === 'PPSI') {
                        markPpsiAsUptoDate(rowData.id);
                      } else {
                        markPpiAsUptoDate(rowData.id);
                      }
                    }}
                    color="secondary"
                    size="medium"
                  >
                    <NotificationsOffIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )} */}

            {hasPublished &&
              !draftExist &&
              discontinuedUpdate.length === 0 &&
              !ifoodUpdates.length && (
                <Tooltip title="Edit Instruction">
                  <IconButton
                    onClick={() => {
                      return isRowPpsi(rowData)
                        ? createDraftPpsi(rowData.id)
                        : createDraftPpi(rowData.id);
                    }}
                    color="secondary"
                    size="medium"
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}

            {ifoodUpdates.length > 0 && rowData.status === 'PUBLISHED' && (
              <Tooltip title={`Unpublish ${rowData.type}`}>
                <IconButton
                  onClick={() => {
                    handleUnpublish(rowData);
                    // return isRowPpsi(rowData)
                    //   ? unpublishPpsi(rowData.id)
                    //   : unpublishPpi(rowData.id);
                  }}
                  color="secondary"
                  size="medium"
                >
                  <RemoveCircleOutlineIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}

            {hasPublished && draftExist && discontinuedUpdate.length === 0 && (
              <Tooltip title="Go to Draft">
                <IconButton
                  onClick={() => {
                    //open existing draft in edit mode
                  }}
                  color="secondary"
                  size="medium"
                >
                  <FileOpenIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}

            {!hasPublished &&
              draftExist &&
              (!ifoodUpdates.length || rowData.status !== 'PUBLISHED') && (
                <Tooltip title="Go to Draft">
                  <IconButton
                    onClick={() => {
                      //open existing draft in edit mode
                    }}
                    color="secondary"
                    size="medium"
                  >
                    <FileOpenIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}

            {!hasUnPublished && hasPublished && discontinuedUpdate.length > 0 && (
              <Tooltip title={`Unpublish ${rowData.type}`}>
                <IconButton
                  onClick={() => {
                    return isRowPpsi(rowData)
                      ? unpublishPpsi(rowData.id)
                      : unpublishPpi(rowData.id);
                  }}
                  color="secondary"
                  size="medium"
                >
                  <RemoveCircleOutlineIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}

            {/* {!hasPublished && ifoodUpdates.length !== 0 && (
              <Tooltip title="Import Ifood Update">
                <IconButton
                  onClick={() => {
                    //import ifood update and open in edit mode
                  }}
                  color="secondary"
                  size="medium"
                >
                  <DownloadIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}

            {!hasPublished && ifoodUpdates.length === 0 && (
              <Tooltip title="Go to Draft">
                <IconButton
                  onClick={() => {
                    //open existing draft in edit mode
                  }}
                  color="secondary"
                  size="medium"
                >
                  <FileOpenIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )} */}
          </>
        );
      },
      label: 'Actions',
      link: rowData => {
        const { updateNotificationList } = getEnrichmentData(rowData);
        const dataType = isRowPpsi(rowData);
        const ifoodUpdates = updateNotificationList.filter(
          i =>
            i.category.includes('IFOOD_UPDATE') &&
            i.message.includes('Discontinued')
        );

        const discontinuedUpdate = updateNotificationList.filter(i =>
          i.category.includes(
            'GLOBAL_PPSI_DISCONTINUED' || 'GLOBAL_PPI_DISCONTINUED'
          )
        );

        const draftExist = hasDraft(rowData);
        const hasPublished = rowData.status !== 'INPROGRESS';
        if (
          !hasPublished ||
          (hasPublished && draftExist && !ifoodUpdates.length > 0)
        ) {
          return isRowPpsi(rowData)
            ? ppsiInProgressRoute(rowData.id)
            : ppiInProgressRoute(rowData.id);
        }
      },
      width: 45,
      grow: 0,
      searchable: false,
      shrink: 0
    },

    PreviewActions: {
      name: 'previewaction',
      calculateCellValue: (rowData, language) => {
        const { updateNotificationList } = getEnrichmentData(rowData);
        const ifoodUpdates = updateNotificationList.filter(
          i =>
            i.category.includes('IFOOD_UPDATE') &&
            i.message.includes('Discontinued')
        );
        let globalUpdate;
        if (updateNotificationList.length > 1 && ifoodUpdates.length > 0) {
          globalUpdate = updateNotificationList.filter(i =>
            i.category.includes('GLOBAL')
          ).length;
        }

        const alternateUpdates = updateNotificationList.filter(i =>
          i.category.includes('ALTERNATE')
        );
        const draftExist = hasDraft(rowData);
        const hasPublished = rowData.status !== 'INPROGRESS';
        // const publishedGlobalPpsis =
        // globalPpsis && globalPpsis.filter(i => i.status === 'PUBLISHED');

        let findGlobalPpsi;
        // =
        //   globalPpsis &&
        //   globalPpsis
        //     .filter(
        //       ppsi => ppsi && ppsi.piaArticleNumber === rowData.piaArticleNumber
        //     )
        //     .filter(
        //       i => i.status === 'PUBLISHED' || i.status === 'UNPUBLISHED'
        //     );
        if (
          (rowData.inProgressPpsiEnrichmentData &&
            Array.isArray(
              rowData.inProgressPpsiEnrichmentData.updateNotificationList
            ) &&
            rowData.inProgressPpsiEnrichmentData.updateNotificationList.length >
              0 &&
            rowData.inProgressPpsiEnrichmentData.updateNotificationList[0]
              .category === 'GLOBAL_PPSI_REPLACED') ||
          (rowData.publishedPpsiEnrichmentData &&
            Array.isArray(
              rowData.publishedPpsiEnrichmentData.updateNotificationList
            ) &&
            rowData.publishedPpsiEnrichmentData.updateNotificationList.length >
              0 &&
            rowData.publishedPpsiEnrichmentData.updateNotificationList[0]
              .category === 'GLOBAL_PPSI_REPLACED') ||
          ifoodUpdates.length
        ) {
          findGlobalPpsi = globalPpsis
            .filter(i => i.piaArticleNumber === rowData.piaArticleNumber)
            .filter(
              i =>
                i.id !==
                ((rowData.publishedPpsiEnrichmentData &&
                  rowData.publishedPpsiEnrichmentData.parentPpsiId) ||
                  (rowData.inProgressPpsiEnrichmentData &&
                    rowData.inProgressPpsiEnrichmentData.parentPpsiId))
            )
            .filter(i => i.status === 'PUBLISHED')
            .sort(function(a, b) {
              var aDate =
                a.publishedPpsiEnrichmentData &&
                a.publishedPpsiEnrichmentData.modifyDate
                  ? new Date(a.publishedPpsiEnrichmentData.modifyDate)
                  : new Date(0);

              var bDate =
                b.publishedPpsiEnrichmentData &&
                b.publishedPpsiEnrichmentData.modifyDate
                  ? new Date(b.publishedPpsiEnrichmentData.modifyDate)
                  : new Date(0);

              return bDate - aDate; // Descending: latest date first
            });
        } else if (
          (rowData.inProgressPpsiEnrichmentData &&
            Array.isArray(
              rowData.inProgressPpsiEnrichmentData.updateNotificationList
            ) &&
            rowData.inProgressPpsiEnrichmentData.updateNotificationList.length >
              0 &&
            rowData.inProgressPpsiEnrichmentData.updateNotificationList[0]
              .category === 'GLOBAL_PPSI_CHANGED') ||
          (rowData.publishedPpsiEnrichmentData &&
            Array.isArray(
              rowData.publishedPpsiEnrichmentData.updateNotificationList
            ) &&
            rowData.publishedPpsiEnrichmentData.updateNotificationList.length >
              0 &&
            rowData.publishedPpsiEnrichmentData.updateNotificationList[0]
              .category === 'GLOBAL_PPSI_CHANGED')
        ) {
          findGlobalPpsi = globalPpsis
            .filter(i => i.piaArticleNumber === rowData.piaArticleNumber)
            .filter(
              i =>
                i.id ===
                ((rowData.publishedPpsiEnrichmentData &&
                  rowData.publishedPpsiEnrichmentData.parentPpsiId) ||
                  (rowData.inProgressPpsiEnrichmentData &&
                    rowData.inProgressPpsiEnrichmentData.parentPpsiId))
            )
            .filter(i => i.status === 'PUBLISHED')
            .sort(
              (a, b) =>
                a.publishedPpsiEnrichmentData &&
                new Date(a.publishedPpsiEnrichmentData.modifyDate) -
                  new Date(b.publishedPpsiEnrichmentData.modifyDate)
            );
        } else if (
          (rowData.inProgressPpsiEnrichmentData &&
            Array.isArray(
              rowData.inProgressPpsiEnrichmentData.updateNotificationList
            ) &&
            rowData.inProgressPpsiEnrichmentData.updateNotificationList.length >
              0 &&
            rowData.inProgressPpsiEnrichmentData.updateNotificationList[0]
              .category === 'GLOBAL_PPSI_DISCONTINUED') ||
          (rowData.publishedPpsiEnrichmentData &&
            Array.isArray(
              rowData.publishedPpsiEnrichmentData.updateNotificationList
            ) &&
            rowData.publishedPpsiEnrichmentData.updateNotificationList.length >
              0 &&
            rowData.publishedPpsiEnrichmentData.updateNotificationList[0]
              .category === 'GLOBAL_PPSI_DISCONTINUED')
        ) {
          findGlobalPpsi = globalPpsis
            .filter(i => i.piaArticleNumber === rowData.piaArticleNumber)
            .filter(
              i =>
                i.id ===
                ((rowData.publishedPpsiEnrichmentData &&
                  rowData.publishedPpsiEnrichmentData.parentPpsiId) ||
                  (rowData.inProgressPpsiEnrichmentData &&
                    rowData.inProgressPpsiEnrichmentData.parentPpsiId))
            )
            .filter(i => i.status === 'UNPUBLISHED');
        } else {
          findGlobalPpsi = globalPpsis
            .filter(i => i.piaArticleNumber === rowData.piaArticleNumber)

            .filter(
              i =>
                i.id ===
                ((rowData.publishedPpsiEnrichmentData &&
                  rowData.publishedPpsiEnrichmentData.parentPpsiId) ||
                  (rowData.inProgressPpsiEnrichmentData &&
                    rowData.inProgressPpsiEnrichmentData.parentPpsiId))
            )
            .sort(
              (a, b) =>
                a.publishedPpsiEnrichmentData &&
                new Date(a.publishedPpsiEnrichmentData.modifyDate) -
                  new Date(b.publishedPpsiEnrichmentData.modifyDate)
            );
        }

        const ppsiImportData = findGlobalPpsi[0];

        let getGlobalPpitoImport;
        // =globalPpis
        // .filter(i => i.relationshipId === rowData.relationshipId)
        // .filter(i => i.id === ((rowData.publishedPPIEnrichmentData && rowData.publishedPPIEnrichmentData.parentPpiId)
        // || (rowData.inProgressPPIEnrichmentData && rowData.inProgressPPIEnrichmentData.parentPpiId)))

        if (
          (rowData.inProgressPPIEnrichmentData &&
            Array.isArray(
              rowData.inProgressPPIEnrichmentData.updateNotificationList
            ) &&
            rowData.inProgressPPIEnrichmentData.updateNotificationList.length >
              0 &&
            (rowData.inProgressPPIEnrichmentData.updateNotificationList[0]
              .category === 'GLOBAL_PPI_REPLACED' ||
              rowData.inProgressPPIEnrichmentData.updateNotificationList[0]
                .category === 'NEW_GLOBAL_PPI_AVAILABLE')) ||
          (rowData.publishedPPIEnrichmentData &&
            Array.isArray(
              rowData.publishedPPIEnrichmentData.updateNotificationList
            ) &&
            rowData.publishedPPIEnrichmentData.updateNotificationList.length >
              0 &&
            (rowData.publishedPPIEnrichmentData.updateNotificationList[0]
              .category === 'GLOBAL_PPI_REPLACED' ||
              rowData.publishedPPIEnrichmentData.updateNotificationList[0]
                .category === 'NEW_GLOBAL_PPI_AVAILABLE'))
        ) {
          getGlobalPpitoImport =
            Object.keys(globalPpis).length > 0 &&
            globalPpis
              .filter(i => i.relationshipId === rowData.relationshipId)
              .filter(
                i =>
                  i.id !==
                  ((rowData.publishedPPIEnrichmentData &&
                    rowData.publishedPPIEnrichmentData.parentPpiId) ||
                    (rowData.inProgressPPIEnrichmentData &&
                      rowData.inProgressPPIEnrichmentData.parentPpiId))
              )
              .filter(i => i.status === 'PUBLISHED')
              .sort(
                (a, b) =>
                  a.publishedPPIEnrichmentData &&
                  new Date(a.publishedPPIEnrichmentData.modifyDate) -
                    new Date(b.publishedPPIEnrichmentData.modifyDate)
              );
        } else {
          getGlobalPpitoImport =
            Object.keys(globalPpis).length > 0 &&
            globalPpis
              .filter(i => i.relationshipId === rowData.relationshipId)
              .filter(
                i =>
                  i.id ===
                  ((rowData.publishedPPIEnrichmentData &&
                    rowData.publishedPPIEnrichmentData.parentPpiId) ||
                    (rowData.inProgressPPIEnrichmentData &&
                      rowData.inProgressPPIEnrichmentData.parentPpiId))
              )
              .sort(
                (a, b) =>
                  a.publishedPPIEnrichmentData &&
                  new Date(a.publishedPPIEnrichmentData.modifyDate) -
                    new Date(b.publishedPPIEnrichmentData.modifyDate)
              );
        }
        // if (
        //   (rowData.inProgressPPIEnrichmentData
        //     ? rowData.inProgressPPIEnrichmentData.updateNotificationList.length
        //       ? rowData.inProgressPPIEnrichmentData.updateNotificationList[0]
        //           .category === 'GLOBAL_PPI_DISCONTINUED'
        //       : false
        //     : false) ||
        //   (rowData.publishedPPIEnrichmentData
        //     ? rowData.publishedPPIEnrichmentData.updateNotificationList.length
        //       ? rowData.publishedPPIEnrichmentData.updateNotificationList[0]
        //           .category === 'GLOBAL_PPI_DISCONTINUED'
        //       : false
        //     : false)
        // ) {
        //   getGlobalPpitoImport = globalPpis
        //     .filter(i => i.relationshipId === rowData.relationshipId)
        //     .filter(i => i.id === ((rowData.publishedPPIEnrichmentData && rowData.publishedPPIEnrichmentData.parentPpiId) || (rowData.inProgressPPIEnrichmentData && rowData.inProgressPPIEnrichmentData.parentPpiId)))
        //     .filter(i => i.status === 'UNPUBLISHED')
        //     // .sort(
        //     //   (a, b) =>
        //     //     new Date(a.publishedPPIEnrichmentData.modifyDate) -
        //     //     new Date(b.publishedPPIEnrichmentData.modifyDate)
        //     // );
        // } else {
        //   getGlobalPpitoImport =
        //     globalPpis &&
        //     globalPpis
        //       .filter(i => i.relationshipId === rowData.relationshipId)
        //       .filter(i => i.id === ((rowData.publishedPPIEnrichmentData && rowData.publishedPPIEnrichmentData.parentPpiId) || (rowData.inProgressPPIEnrichmentData && rowData.inProgressPPIEnrichmentData.parentPpiId)))
        //       .filter(i => i.status === 'PUBLISHED')
        //       // .sort(
        //       //   (a, b) =>
        //       //     new Date(a.publishedPPIEnrichmentData.modifyDate) -
        //       //     new Date(b.publishedPPIEnrichmentData.modifyDate)
        //       // );
        // }

        // if(rowData.inProgressPPIEnrichmentData && rowData.inProgressPPIEnrichmentData.updateNotificationList[0].category==="GLOBAL_PPI_DISCONTINUED"){

        //   getGlobalPpitoImport =
        //   globalPpis
        //   .filter(i => i.relationshipId === rowData.relationshipId)
        //     .filter(i => i.status === 'UNPUBLISHED')
        //     .sort((a, b) => new Date(a.publishedPPIEnrichmentData.modifyDate) - new Date(b.publishedPPIEnrichmentData.modifyDate))
        // }else{
        // getGlobalPpitoImport =
        //   globalPpis &&
        //   globalPpis
        //     .filter(i => i.relationshipId === rowData.relationshipId)
        //     .filter(i => i.status === 'PUBLISHED')
        //     .sort((a, b) => new Date(a.publishedPPIEnrichmentData.modifyDate) - new Date(b.publishedPPIEnrichmentData.modifyDate))

        // }

        const finalGlobalPpitoImport =
          getGlobalPpitoImport[getGlobalPpitoImport.length - 1];
        // console.log(finalGlobalPpitoImport,"finalGlobalPpitoImport")
        // const finalGlobalPpitoImport = getGlobalPpitoImport[0];
        return (
          <>
            {rowData.type === 'PPSI' &&
              (((rowData.inProgressPpsiEnrichmentData
                ? rowData.inProgressPpsiEnrichmentData.parentPpsiId
                : rowData.publishedPpsiEnrichmentData.parentPpsiId) &&
                ppsiImportData !== undefined) ||
                ifoodUpdates.length > 0) && (
                <Tooltip
                  title={
                    ifoodUpdates.length > 0
                      ? `Preview`
                      : `Preview Global ${rowData.type}`
                  }
                >
                  <IconButton
                    onClick={() => {
                      if (ifoodUpdates.length > 0 && !isGlobalUser) {
                        dispatch(fetchPpisRelatedToPpsi(rowData.id, 'updates'));
                        setPpsiId(rowData.id);
                        setCurrentPpsi({
                          rowData,
                          language: language.language,
                          ifoodUpdates,
                          globalUpdate
                        });
                        // const {
                        //   ppiDetails,
                        //   referencedIFoodData
                        // } = getEnrichmentData(rowData);
                        // let usedPpis = [];
                        // const ppiDataIds = ppiDetails
                        //   .filter(ppiDetail => ppiDetail.ppiEnrichmentDataId)
                        //   .map(ppiDetail => ppiDetail.ppiEnrichmentDataId);
                        // // referencedIngredientEntities
                        // const ppisRelatedToPpsi = ppiss.filter(ppi=>getEnrichmentData(ppi).upToDate)
                        // if (ppiDataIds.length) {
                        //   usedPpis =
                        //     ppiss &&
                        //     ppiss
                        //       .filter(
                        //         ppi =>
                        //           ppi.publishedPPIEnrichmentData &&
                        //           ppiDataIds.includes(
                        //             ppi.publishedPPIEnrichmentData.id
                        //           )
                        //       )
                        //       .map(ppi => ppi.publishedPPIEnrichmentData);
                        // }

                        // const ppsi = temp > 0 && ppisRelatedToPpsi.length && stichPpsi(
                        //   getPublishedData(rowData),
                        //   stitchPpis(usedPpis),
                        //   referencedIFoodData.referencedIngredientEntities,
                        //   language.language
                        // );
                        // const getExcludedItemCodes =
                        //   ppiDetails &&
                        //   ppiDetails
                        //     .filter(i => i.ppiNotRequired === true)
                        //     .map(i => i.itemCode);

                        // const ppiWithoutExcludeData =
                        //   ppsi &&
                        //   ppsi.ppiDetails.filter(
                        //     i => !getExcludedItemCodes.includes(i.itemCode)
                        //   );
                        // const finalPpsi = {
                        //   ...ppsi,
                        //   ppiDetails: ppiWithoutExcludeData,
                        //   updateNotificationList: updateNotificationList
                        // };
                        //  temp > 0 && ppisRelatedToPpsi.length && openPreviewPPSI(finalPpsi, ifoodUpdates.length>0 ? language.language : 'EN-IF');
                        // setPpsiId(null);
                      } else {
                        const {
                          ppiDetails,
                          referencedIFoodData
                        } = ppsiImportData[PpsiEnrichmentData.PUBLISHED];

                        const ppiDataIds = ppiDetails
                          .filter(ppiDetail => ppiDetail.ppiEnrichmentDataId)
                          .map(ppiDetail => ppiDetail.ppiEnrichmentDataId);
                        // referencedIngredientEntities

                        const usedPpis =
                          globalPpis &&
                          globalPpis
                            .filter(
                              ppi =>
                                ppi.publishedPPIEnrichmentData &&
                                ppiDataIds.includes(
                                  ppi.publishedPPIEnrichmentData.id
                                )
                            )
                            .map(ppi => ppi.publishedPPIEnrichmentData);
                        const ppsi = stichPpsi(
                          getPublishedData(ppsiImportData),
                          stitchPpis(usedPpis),
                          referencedIFoodData.referencedIngredientEntities,
                          'EN-IF'
                        );
                        const getExcludedItemCodes =
                          ppiDetails &&
                          ppiDetails
                            .filter(i => i.ppiNotRequired === true)
                            .map(i => i.itemCode);

                        const ppiWithoutExcludeData =
                          ppsi &&
                          ppsi.ppiDetails.filter(
                            i => !getExcludedItemCodes.includes(i.itemCode)
                          );

                        const finalPpsi = {
                          ...ppsi,
                          ppiDetails: ppiWithoutExcludeData,
                          updateNotificationList: updateNotificationList
                        };
                        openPreviewPPSI(finalPpsi, 'EN-IF');
                      }
                    }}
                    color="secondary"
                    size="medium"
                  >
                    <PreviewIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
            {((rowData.type === 'PPI' &&
              rowData.relationshipId &&
              finalGlobalPpitoImport !== undefined) ||
              ifoodUpdates.length > 0) && (
              <Tooltip
                title={
                  ifoodUpdates.length > 0
                    ? `Preview`
                    : `Preview Global ${rowData.type}`
                }
              >
                <IconButton
                  onClick={() => {
                    // const globalPpi = globalPpis.find(
                    //   ppi => ppi && ppi.id === rowData.parentPpiId
                    // );
                    openPreviewPPI(
                      ifoodUpdates.length > 0
                        ? getEnrichmentData(rowData)
                        : {
                            ...finalGlobalPpitoImport.publishedPPIEnrichmentData,
                            updateNotificationList: updateNotificationList
                          },
                      ifoodUpdates.length > 0 ? language.language : 'EN-IF'
                    );
                  }}
                  color="secondary"
                  size="medium"
                >
                  <PreviewIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </>
        );
      },
      label: '',
      // link: rowData => {
      //   return isRowPpsi(rowData)
      //     ? ppsiInProgressRoute(rowData.id)
      //     : ppiInProgressRoute(rowData.id);
      // },
      width: 45,
      grow: 0,
      searchable: false,
      shrink: 0
    }
  };

  if (isFetching) {
    return <ProgressFullscreen />;
  }

  let allData = [];
  let data = [];
  if (ppsis.size || ppis.size) {
    allData = createTableData(ppsis, ppis);
    const allDatas = allData.toJS();
    data = allDatas && allDatas.filter(i => i.status !== 'UNPUBLISHED');
  }
  View.UpdatesList.visit();

  return (
    <PaperContainer showProgress={!isFetched}>
      {previewNodePPI}
      {previewNodePPSI}
      <Table
        title="updatesList.updatesTableHeader"
        data={data}
        columns={[
          UpdatesColumns.Code,
          UpdatesColumns.PresentationName,
          UpdatesColumns.Type,
          UpdatesColumns.Status,
          UpdatesColumns.Category,
          UpdatesColumns.CategoryMessage,
          UpdatesColumns.Updates,
          UpdatesColumns.AllOtherActions,
          UpdatesColumns.PreviewActions
        ]}
        getObjectId={object => object.id}
        defaultSorting={[{ columnName: 'code', direction: 'asc' }]}
        cellRenderer={UpdatesColumns.PresentationName.cellRenderer}
        selectable
      />
    </PaperContainer>
  );
};

export default NewUpdatesListView;
